/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SpeakerSegment = {
  /**
   * Detected speaker identifier for this segment, for example 'Speaker-1'.
   */
  speaker: string;
  /**
   * The transcribed text for this speaker segment.
   */
  text: string;
  /**
   * Confidence score from 0 to 1 for this segment.
   */
  confidence?: number | undefined;
  /**
   * Start offset of the segment in milliseconds.
   */
  offsetMs?: number | undefined;
  /**
   * Duration of the segment in milliseconds.
   */
  durationMs?: number | undefined;
};

/** @internal */
export const SpeakerSegment$inboundSchema: z.ZodType<
  SpeakerSegment,
  z.ZodTypeDef,
  unknown
> = z.object({
  speaker: z.string(),
  text: z.string(),
  confidence: z.number().optional(),
  offset_ms: z.number().int().optional(),
  duration_ms: z.number().int().optional(),
}).transform((v) => {
  return remap$(v, {
    "offset_ms": "offsetMs",
    "duration_ms": "durationMs",
  });
});
/** @internal */
export type SpeakerSegment$Outbound = {
  speaker: string;
  text: string;
  confidence?: number | undefined;
  offset_ms?: number | undefined;
  duration_ms?: number | undefined;
};

/** @internal */
export const SpeakerSegment$outboundSchema: z.ZodType<
  SpeakerSegment$Outbound,
  z.ZodTypeDef,
  SpeakerSegment
> = z.object({
  speaker: z.string(),
  text: z.string(),
  confidence: z.number().optional(),
  offsetMs: z.number().int().optional(),
  durationMs: z.number().int().optional(),
}).transform((v) => {
  return remap$(v, {
    offsetMs: "offset_ms",
    durationMs: "duration_ms",
  });
});

export function speakerSegmentToJSON(speakerSegment: SpeakerSegment): string {
  return JSON.stringify(SpeakerSegment$outboundSchema.parse(speakerSegment));
}
export function speakerSegmentFromJSON(
  jsonString: string,
): SafeParseResult<SpeakerSegment, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpeakerSegment$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpeakerSegment' from JSON`,
  );
}
